import * as yup from 'yup'
import { shapeSchemaByMetadata } from '@/helpers/field'

export const noteSchema = shapeSchemaByMetadata
